import { AnswerSet } from 'src/store/sellerFlow/AnswerSet';

export function buildAccountCreationAnswers(
  fullName: string,
  email: string,
  phoneNumber?: string,
): AnswerSet {
  const answers = {
    'seller.full_name': fullName,
    'seller.email': email,
  };

  if (phoneNumber) {
    answers['seller.phone_number'] = phoneNumber;
  }
  return answers;
}

// Record<string,any> will still allow things like object.methodName(....)
// since that is a valid way to access objects. This type at least tells
// typescript this return value should not have any methods
type Primitives = string | null | number | boolean;
// eslint-disable-next-line
interface ObjectTree extends Record<string, Primitives | ObjectTree> {}

export const getAnswersFromLocalStorage = (sellerInputUUID: string): ObjectTree => {
  const answersValue = window.localStorage.getItem(`answers_${sellerInputUUID}`);
  if (!answersValue) {
    return {};
  }
  return JSON.parse(answersValue);
};
